<template>
  <div id="app" :style="appStyle" @mousemove="onMouseMove">
    <loader></loader>
    <navbar></navbar>
    <timeline :display="childDisplay"></timeline>
    <about></about>
    <slider></slider>
  </div>
</template>

<script>
import Store from './store/Store'
import {mapGetters} from 'vuex'

import Loader from './components/Loader/Loader'
import Slider from './components/Slider/Slider'
import Timeline from './components/Timeline/Timeline'
import Navbar from './components/Navbar/Navbar'
import About from './components/About/About'

export default {
  name: 'app',
  store: Store,
  components: {
    Loader,
    Slider,
    Timeline,
    Navbar,
    About
  },
  data () {
    return {
      slideInterval: null,
      timerMax: 5000
    }
  },
  computed: {
    ...mapGetters([
      'touchDevice',
      'mousePosition',
      'clientDimensions',
      'currentIndex',
      'toggleHover',
      'timer',
      'aboutDisplay',
      'loaded'
    ]),
    childDisplay () {
      if (this.toggleHover && !this.touchDevice) {
        return false
      } else {
        return true
      }
    },
    appStyle () {
      return 'height: ' + this.clientDimensions.height + 'px'
    }
  },
  watch: {
    currentIndex () {
      this.$store.dispatch('setTimer', 0)
    },
    toggleHover () {
      if (!this.touchDevice) {
        if (this.toggleHover !== false) {
          this.pauseTimer()
        } else {
          this.playTimer()
        }
      }
    },
    aboutDisplay () {
      if (this.aboutDisplay === true) {
        this.pauseTimer()
      } else {
        this.playTimer()
      }
    },
    loaded () {
      if (this.loaded === true) {
        this.playTimer()
      }
    }
  },
  methods: {
    onMouseMove (e) {
      if (!this.aboutDisplay && !this.touchDevice) {
        this.$store.dispatch('setMousePosition', {x: e.clientX, y: e.clientY})
      }
    },
    onMouseLeave () {
      this.$store.dispatch('setMouseInWindow', false)
    },
    onMouseEnter () {
      this.$store.dispatch('setMouseInWindow', true)
    },
    onResize () {
      let width = window.innerWidth
      let height = window.innerHeight
      this.$store.dispatch('setClientDimensions', {width: width, height: height, hoverZone: width / 10})
    },
    pauseTimer () {
      clearInterval(this.slideInterval)
    },
    playTimer () {
      this.slideInterval = setInterval(() => {
        this.$store.dispatch('setTimer', this.timer += 1)
        if (this.timer > this.timerMax) {
          this.$store.dispatch('setRequestNextSlide', true)
          this.$store.dispatch('setTimer', 0)
        }
      }, 1)
    },
    isTouchDevice () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
        ) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    // this.playTimer()

    if (this.isTouchDevice()) {
      this.$store.dispatch('setTouchDevice', true)
    } else {
      this.$store.dispatch('setTouchDevice', false)
    }
  },
  created () {
    this.onResize()

    window.addEventListener('resize', this.onResize)
    document.addEventListener('mouseleave', this.onMouseLeave)
    document.addEventListener('mouseenter', this.onMouseEnter)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('mouseleave', this.onMouseLeave)
    document.removeEventListener('mouseenter', this.onMouseEnter)
  }
}
</script>

<style lang="scss">
@import "./main";

#app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// App.vue?0be4a833